module.exports = __webpack_public_path__ + "static/media/btn_10.6f2f0417.png";